var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecommend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 75,
    viewBox: "0 0 63 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0322 27.948L26.2378 32.6187H30.9756H57.2475C58.1865 32.6187 58.9713 33.4035 58.9713 34.3424V38.9214V39.1559L58.9987 39.3888C59.0073 39.4619 58.9884 39.678 58.8695 39.9009L58.7894 40.0511L58.7223 40.2076L46.7062 68.2452C46.7058 68.2463 46.7053 68.2473 46.7049 68.2483C46.1168 69.6079 44.7058 70.4975 43.1522 70.4143L43.0453 70.4086H42.9382H11.4576C7.37066 70.4086 4.01016 67.0481 4.01016 62.9611V34.3424V34.2372L4.00463 34.1322C3.95372 33.1649 4.3285 32.2181 5.07422 31.5L5.16142 31.416L5.24338 31.3269L28.7492 5.77716L29.7024 6.73046C30.0676 7.12929 30.2647 7.61285 30.2953 8.05497V8.76299L27.0322 27.948Z",
    stroke: "white",
    strokeWidth: 8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommend);
export default __webpack_public_path__ + "static/media/recommend.7a4d4d18dced46c44a9213f50772317c.svg";
export { ForwardRef as ReactComponent };